import React, { useState, useEffect } from 'react';
import '../App.scss'

import IconButton from '@mui/material/IconButton';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';

import Card from '@mui/material/Card';

export default function HangulConsonants() {
  const hangulData = [
    {
      character: '가',
      pronunciation: 'ka',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ka.mp3',
    },
    {
      character: '나',
      pronunciation: 'na',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/na.mp3',
    },
    {
      character: '다',
      pronunciation: 'ta',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ta.mp3',
    },
    {
      character: '라',
      pronunciation: 'ra',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ra.mp3',
    },
    {
      character: '마',
      pronunciation: 'ma',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ma.mp3',
    },
    {
      character: '바',
      pronunciation: 'pa',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/pa.mp3',
    },
    {
      character: '사',
      pronunciation: 'sa',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/sa.mp3',
    },
    {
      character: '자',
      pronunciation: 'cha',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/cha.mp3',
    },
    {
      character: '하',
      pronunciation: 'ha',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ha.mp3',
    },
    {
      character: '아',
      pronunciation: 'a',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/a.mp3',
    },
    {
      character: '카',
      pronunciation: 'ka',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ka1.mp3',
    },
    {
      character: '타',
      pronunciation: 'ta',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ta1.mp3',
    },
    {
      character: '파',
      pronunciation: 'pa',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/pa1.mp3',
    },
    {
      character: '차',
      pronunciation: 'cha',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/cha1.mp3',
    },
    {
      character: '까',
      pronunciation: 'kka',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/kka.mp3',
    },
    {
      character: '따',
      pronunciation: 'tta',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/tta.mp3',
    },
    {
      character: '빠',
      pronunciation: 'ppa',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ppa.mp3',
    },
    {
      character: '싸',
      pronunciation: 'ssa',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ssa.mp3',
    },
    {
      character: '짜',
      pronunciation: 'ccha',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/consonants/ccha.mp3',
    },
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [audio, setAudio] = useState(new Audio(hangulData[currentIndex].audioUrl));

  useEffect(() => {
    setAudio(new Audio(hangulData[currentIndex].audioUrl));
  }, [currentIndex]);

  const playSound = () => {
    audio.play();
    // 1秒後に次のインデックスに移動します
    setTimeout(() => {
      setCurrentIndex((currentIndex + 1) % hangulData.length);
    }, 500); // 1000ミリ秒 = 1秒
  };

  const currentHangul = hangulData[currentIndex];

  return (
    <>
      <div className="consonants">
        <Card className="vowel_card" variant="outlined">
          <div className="vowel_character">{currentHangul.character}</div>
          <div className="vowel_pronunciation"><b><small>[ </small>{currentHangul.pronunciation}<small> ]</small></b></div>
          <IconButton className="vowel_button" onClick={playSound} aria-label="play">
            <PlayCircleFilledIcon />
          </IconButton>
          <p>{currentIndex + 1}/19</p>
        </Card>
      </div>
    </>
  );
}

